export enum RoleType {
  INT = 'Internal'
  , CLI = 'Client (Default)'
  , Menu = 'Menu Role (Relegated)'
  , Data = 'Data Role (Relegated)'
  , ANON = 'Anonymous'
}
